import I18n from 'i18n-js';
import React from 'react';
import SignupSigninModal from '@reverbdotcom/commons/src/components/signup_signin_modal';
import LocationUtil from '../shared/location_util';
import { FOLLOW_PROMPT_PARAM } from '../shared/constants';
import { HeartEmptyIcon } from '@reverbdotcom/cadence/icons/react';
import { RCIcon } from '@reverbdotcom/cadence/components/RCIcon/RCIcon';
import classNames from 'classnames';
import { EntityType, EntityTypeName } from '@reverbdotcom/commons/src/favorites/entity_type';

interface Props {
  entityType: EntityTypeName; // Remove as a prop and replace with `mapFavoriteToEntityType(useFindFavorite().favorite)` when FollowButtonContainer is deprecated
  modalOpen: boolean; // Remove as a prop and replace with `useFindFavorite().displayedModal === FavoriteModal.Signup` when FollowButtonContainer is deprecated
  renderWithBanner: boolean;
  disabled: boolean;
  onModalClose?: () => void;
}

export const LoggedOutFavoriteButton = function (props: Props) {
  // Remove this local state when FollowButtonContainer is deprecated
  const [modalOpen, setModalOpen] = React.useState<boolean>(props.modalOpen);

  const handleClick = function (evt) {
    evt.preventDefault();

    if (props.disabled) {
      return;
    }

    setModalOpen(true);
  };

  const handleModalClose = function () {
    setModalOpen(false);

    if (props.onModalClose) {
      props.onModalClose();
    }
  };

  const buttonType = (props.entityType === EntityType.Product || props.renderWithBanner) ? 'secondary' : 'link';
  const classes = classNames(
    'favorite-button__button',
    {
      'favorite-button__button--link': buttonType === 'link',
      'favorite-button__button--secondary': buttonType === 'secondary',
      'favorite-button__button--disabled': props.disabled,
    },
  );

  return (
    <div className="favorite-button">
      <button
        type="button"
        className={classes}
        onClick={handleClick}
        data-disabled={props.disabled || null}
      >
        <RCIcon svgComponent={HeartEmptyIcon} inline />
        {I18n.t(`discovery.favorites.favoriteButton.save.${props.entityType}`)}
      </button>
      <SignupSigninModal
        onRequestClose={handleModalClose}
        active={modalOpen}
        message={I18n.t('discovery.searchSignup.fullLoginMessage')}
        redirectTo={LocationUtil.currentPageWithParams({ [FOLLOW_PROMPT_PARAM]: true })}
        trackSource="FavoriteButton"
      />
    </div>
  );
};
